export default {
    upload_photos: {
        heading: 'Galerija',
        content: 'Slike su dobar način da prikažete koliko je dobar vaš proizvod.',
    },
    schedule: {
        heading: 'Raspored',
        content_create: 'Kreirajte raspored za uslugu',
        content: 'Tvoji rasporedi',
    },
    buttons: {
        create_new: 'Dodaj novi raspored',
        use_existing: 'Iskoristi postojeći raspored',
        go_to_offers: 'Idi na usluge',
    },
    categories: 'Kategorije',
    choose_existing: 'Izaberite jedan od postojećih rasporeda',
    create_new: 'Kreirajte novi raspored',
    add_availability_to_offer:
        'Odabirom ovog rasporeda znači da će sve usluge dijeliti isti, tako da rezervacijom određenog vremenskog perioda na rasporedu, taj vremenski period bi bio nedostupan na svim uslugama koje ga dijele.',
    remove_availability: 'Da li ste sigurni da želite da uklonite ovaj raspored na ovoj usluzi?',
}
